<template>
  <SettingsPageLayout>
    <Card class="mt-6">
      <CardContent class="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div class="space-y-1">
          <CardTitle>Billing</CardTitle>
          <CardDescription>Manage your payment methods, see your billing history, etc.</CardDescription>
        </div>

        <HFetchQuery :query="query" hide-retry>
          <template #loading>
            <div class="h-6 w-6 animate-spin rounded-full border-2 border-gray-300 border-t-gray-600"></div>
          </template>
          <template #default="{ data }">
            <Button as="a" :href="data.session" target="_blank" @click="openBillingPortal($event, data.session)">
              Manage Billing
            </Button>
          </template>
        </HFetchQuery>
      </CardContent>
    </Card>
  </SettingsPageLayout>
</template>

<script setup lang="ts">
import SettingsPageLayout from '@/components/layouts/SettingsPageLayout/index.vue';
import { Card, CardContent, CardDescription, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import HFetchQuery from '@/lib/hfetch/HFetchQuery.vue';
import { useHFetchQuery } from '@/lib/hfetch/useHFetchQuery';
import { Api } from '@/api';
import { toast } from 'vue-sonner';

const query = useHFetchQuery(() => Api.Team.getBillingSession());

const openBillingPortal = (event: MouseEvent, url: string) => {
  if (!url.startsWith('http')) {
    event.preventDefault();
    toast.success('Billing portal ready', {
      description: 'In production, this links to the Stripe billing page.',
    });
  }
};
</script>
